import { render, staticRenderFns } from "./ProfileCompletion.vue?vue&type=template&id=1d66021b&"
import script from "./ProfileCompletion.vue?vue&type=script&lang=js&"
export * from "./ProfileCompletion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports